export const CLIENT_LOGOS = Array.from({ length: 53 }, (_, i) => ({
  src: `/logos/logo-${String(i + 1).padStart(2, "0")}.png`,
}));
